import React, { useState } from 'react';
import I18n from 'i18n-js';
import { RCAlertBox } from '@reverbdotcom/commons/src/rc/RCAlertBox';
import {
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
  core_apimessages_Error,
} from '../schemas/rql';

interface Props {
  selectedPaymentMethod: CheckoutPaymentMethodType;
  disableSubmitButton: boolean;
  submitDiscountCode: (discountCode: string) => any;
  errors: core_apimessages_Error[];
}

export function CheckoutDiscountCodeForm(props: Props) {
  const [discountCode, setDiscountCode] = useState('');
  const { submitDiscountCode, disableSubmitButton, selectedPaymentMethod, errors } = props;

  const showAffirmWarning = selectedPaymentMethod === CheckoutPaymentMethodType.AFFIRM;
  const submitButtonValue = disableSubmitButton ?
    I18n.t('discovery.wait') :
    I18n.t('discovery.promoCodeRedemptionForm.submit');

  const onSubmitDiscountCode = (e) => {
    e.preventDefault();
    submitDiscountCode(discountCode);
  };

  return (
    <div className="site-module__content">
      <h3 className="size-100 weight-bold mb-1">
        {I18n.t('discovery.promoCodeRedemptionForm.header')}
      </h3>
      {errors.length > 0 &&
        <div className="mtb-2">
          <ErrorAlert errors={errors} />
        </div>
      }
      <form onSubmit={onSubmitDiscountCode}>
        <div className="g-container">
          <div className="g-col-9">
            <input
              type="text"
              name="discount_code"
              id="discount_code"
              placeholder={I18n.t('discovery.promoCodeRedemptionForm.placeholder')}
              className="width-100"
              value={discountCode}
              onChange={e => setDiscountCode(e.target.value)}
            />
          </div>
          <div className="g-col-3">
            <input
              type="submit"
              className="button button--white width-100"
              value={submitButtonValue}
              disabled={disableSubmitButton}
            />
          </div>
        </div>
        {showAffirmWarning &&
          <div className="mt-2" data-affirm-warning>
            <RCAlertBox type="warning" small>
              <p className="mb-0 lh-120 icon-l-exclamation-triangle">
                {I18n.t('discovery.promoCodeRedemptionForm.affirmWarning')}
              </p>
            </RCAlertBox>
          </div>
        }
      </form>
    </div>
  );
}

function ErrorAlert({ errors }: { errors: core_apimessages_Error[] }) {
  return (
    <RCAlertBox type="error">
      {errors.map((error) => {
        return (
          <li key={error.field + error.message}>
            {error.message}
          </li>
        );
      })}
    </RCAlertBox>
  );
}

export default CheckoutDiscountCodeForm;
